import { render, staticRenderFns } from "./FormEquipe.vue?vue&type=template&id=0b4b054f&scoped=true&"
import script from "./FormEquipe.vue?vue&type=script&lang=js&"
export * from "./FormEquipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b054f",
  null
  
)

export default component.exports